import { c as _c } from "react/compiler-runtime";
import { useCountDownTimer } from "@website/accommodation-ui/hotel-last-second/count-down-timer/count-down-timer.hook";
import { CountDownTimerType } from "@website/accommodation-ui/hotel-last-second/count-down-timer/count-down-timer.type";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { Skeleton } from "@website/ui/skeleton";
import { FC } from "react";
export const CountDownTimer: FC<CountDownTimerType> = t0 => {
  const $ = _c(28);
  const {
    wrapperClassName,
    textWrapperClassName,
    className,
    chipClassName,
    showTimer: t1,
    onTimeEnd,
    resetOnEnd
  } = t0;
  const showTimer = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== onTimeEnd || $[1] !== resetOnEnd) {
    t2 = {
      onTimeEnd,
      resetOnEnd
    };
    $[0] = onTimeEnd;
    $[1] = resetOnEnd;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    timeLeft
  } = useCountDownTimer(t2);
  if (timeLeft && showTimer) {
    const t3 = `w-full ${wrapperClassName ?? ""}`;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MaterialIcon className="text-2xl" name="timer" variant="outlined" />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    const t5 = `flex gap-2 md:justify-between ${textWrapperClassName ?? ""}`;
    const t6 = `flex ${className ?? ""}`;
    const t7 = timeLeft?.hours;
    let t8;
    if ($[4] !== t7) {
      t8 = <span>{t7}</span>;
      $[4] = t7;
      $[5] = t8;
    } else {
      t8 = $[5];
    }
    let t9;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <span>:</span>;
      $[6] = t9;
    } else {
      t9 = $[6];
    }
    const t10 = timeLeft?.minutes;
    let t11;
    if ($[7] !== t10) {
      t11 = <span>{t10}</span>;
      $[7] = t10;
      $[8] = t11;
    } else {
      t11 = $[8];
    }
    let t12;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <span>:</span>;
      $[9] = t12;
    } else {
      t12 = $[9];
    }
    const t13 = timeLeft?.seconds;
    let t14;
    if ($[10] !== t13) {
      t14 = <span>{t13}</span>;
      $[10] = t13;
      $[11] = t14;
    } else {
      t14 = $[11];
    }
    let t15;
    if ($[12] !== t11 || $[13] !== t14 || $[14] !== t6 || $[15] !== t8) {
      t15 = <span className={t6} dir="ltr">{t8}{t9}{t11}{t12}{t14}</span>;
      $[12] = t11;
      $[13] = t14;
      $[14] = t6;
      $[15] = t8;
      $[16] = t15;
    } else {
      t15 = $[16];
    }
    let t16;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <span>تا پایان</span>;
      $[17] = t16;
    } else {
      t16 = $[17];
    }
    let t17;
    if ($[18] !== t15 || $[19] !== t5) {
      t17 = <span className={t5}>{t15}{t16}</span>;
      $[18] = t15;
      $[19] = t5;
      $[20] = t17;
    } else {
      t17 = $[20];
    }
    const t18 = `text-on-color-high-emphasis flex w-full items-center justify-center gap-3 md:justify-start md:gap-2 md:p-1 ${chipClassName ?? ""}`;
    let t19;
    if ($[21] !== t17 || $[22] !== t18) {
      t19 = <MiniChips StartIcon={t4} children={t17} className={t18} color="primary" size="large" variant="round-contained" />;
      $[21] = t17;
      $[22] = t18;
      $[23] = t19;
    } else {
      t19 = $[23];
    }
    let t20;
    if ($[24] !== t19 || $[25] !== t3) {
      t20 = <div className={t3}>{t19}</div>;
      $[24] = t19;
      $[25] = t3;
      $[26] = t20;
    } else {
      t20 = $[26];
    }
    return t20;
  }
  let t3;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-[32px] w-full overflow-hidden rounded-full md:h-[28px] md:w-[145px]"><Skeleton height={32} /></div>;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  return t3;
};